// extracted by mini-css-extract-plugin
export default {"root":"sPUcWhH2ApzFNQC5JlR2","row":"vKCWbt1LL9RpbP5zg8s2","info":"WqiQHmDatnZpI1MTvRAA","title":"QDcjl6VFXgAoBvINnHif","subtitle":"zmqy9xuIZgaOHaEid6Kp","btn":"yx_X9fbpSfXoBrJOL8xX"};